import { render, staticRenderFns } from "./BolgeselSatislar.vue?vue&type=template&id=16184ca0&"
import script from "./BolgeselSatislar.vue?vue&type=script&lang=js&"
export * from "./BolgeselSatislar.vue?vue&type=script&lang=js&"
import style0 from "./BolgeselSatislar.vue?vue&type=style&index=0&id=16184ca0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports